import { render } from "./ListeEtudiantPage.vue?vue&type=template&id=5e89bd42&ts=true"
import script from "./ListeEtudiantPage.vue?vue&type=script&lang=ts"
export * from "./ListeEtudiantPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__